import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  addbillinginvoicesLoading: false,
  allbillinginvoicesConsumer: [],
  allbillinginvoices: [],
  allbillingRecurringinvoices: [],
  allPaidInvoices: [],
  CashandChequeInvoice: [],
};

export const skypointBillinginvoiceState = createSlice({
  name: "skypointBillinginvoiceReducer",
  initialState,
  reducers: {
    setSkypointLoading(state, action) {
      return { ...state, loading: action?.payload };
    },

    setSkypointAddBillingInvoicesLoading(state, action) {
      return { ...state, addbillinginvoicesLoading: action?.payload };
    },

    setSkypointAllBillinginvoicesConsumers(state, action) {
      return { ...state, loading: false, allbillinginvoicesConsumer: action?.payload };
    },

    setSkypointAllBillinginvoices(state, action) {
      return { ...state, loading: false, allbillinginvoices: action?.payload };
    },

    setSkypointAllBillingRecurringinvoices(state, action) {
      return { ...state, loading: false, allbillingRecurringinvoices: action?.payload };
    },

    setSkypointAllBillingPaidinvoices(state, action) {
      return { ...state, loading: false, allPaidInvoices: action?.payload };
    },

    setSkypointAllCashChequeInvoices(state, action) {
      return { ...state, loading: false, CashandChequeInvoice: action?.payload };
    },

    reset() {
      return initialState;
    },
  },
});

export const {
  setSkypointLoading,
  setSkypointAddBillingInvoicesLoading,
  setSkypointAllBillinginvoicesConsumers,
  setSkypointAllBillinginvoices,
  setSkypointAllBillingRecurringinvoices,
  setSkypointAllBillingPaidinvoices,
  setSkypointAllCashChequeInvoices,
} = skypointBillinginvoiceState.actions;

export default skypointBillinginvoiceState.reducer;
